import React, { Fragment } from 'react';
import { AxiosAPI, getGroupID, getUserID } from '../../../../helpers/AxiosAPI';
import { API_CloudBeds_Connection, API_CloudBeds } from '../../../../constants/APIs';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import userManager from '../../../../helpers/userManage';
import { Changecloudbeds, ChangeCloudbedsCode } from '../../../../redux/actions';
import { Spinner } from 'reactstrap';
class Tokens extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        let url = this.props.history.location.pathname;
        const { locale, loginUser, oidc } = this.props;
        var restUrl = window.location.href.substring(window.location.href.lastIndexOf("?") + 6,
            window.location.href.lastIndexOf("&"));
        if (restUrl !== 'http:') {
            this.props.ChangeCloudbedsCode('');
            AxiosAPI({
                method: 'post',
                url: `${API_CloudBeds_Connection}/code/000?group_id=${getGroupID()}&property_id=${this.props.propertyId}`,
                data: ({
                    code: restUrl,
                })
            }).then((m) => {
                localStorage.setItem("ShowCloudbedsMessage", true);
                window.location.href = `/app/pages/integration`;             
            });
        } else if (oidc.user !== null) {
            this.props.ChangeCloudbedsCode('');
            window.location.href = `/app/pages/integration`;
        }
    }

    render() {
        return (
            <Fragment>
                <div className="mx-auto my-auto">
                    <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ authUser, settings, oidc }) => {
    const { user: loginUser } = authUser;
    const { locale, propertyId, cloudBedsId } = settings;
    return { loginUser, locale, oidc, propertyId, cloudBedsId };
};

export default injectIntl(connect(mapStateToProps, { ChangeCloudbedsCode })(Tokens));